export const POPUP_UNFINISHED_SEEN = 'POPUP_UNFINISHED_SEEN';
export const POPUP_DIPLOMA_SEEN = 'POPUP_DIPLOMA_SEEN';

export function popupUnfinishedSeen() {
  return {
    type: POPUP_UNFINISHED_SEEN,
  };
}

export function popupDiplomaSeen() {
  return {
    type: POPUP_DIPLOMA_SEEN,
  };
}
